import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { dbFinancialPromotions as db } from "../../../../backend/firebaseConfig";

const GENERATED_CONTENT_COLLECTION = "Financial Promotions Content";

const cleanId = (value = "") => {
  return String(value)
    .replace(/^legacy-/, "")
    .replace(/^\/?Financial Promotions Content\//, "")
    .trim();
};

export const approveGeneratedFinancialPromotionResponse = async ({
  sourceResponseId = "",
  approvedSubmissionId = "",
  approvedByEmail = "",
}) => {
  const cleanResponseId = cleanId(sourceResponseId);

  if (!cleanResponseId) {
    throw new Error("Missing generated response ID.");
  }

  const matchedDocs = new Map();

  const directDocRef = doc(db, GENERATED_CONTENT_COLLECTION, cleanResponseId);
  const directDocSnap = await getDoc(directDocRef);

  if (directDocSnap.exists()) {
    matchedDocs.set(directDocSnap.id, directDocRef);
  }

  const responsesRef = collection(db, GENERATED_CONTENT_COLLECTION);

  const responseIdSnapshot = await getDocs(
    query(responsesRef, where("responseId", "==", cleanResponseId)),
  );

  responseIdSnapshot.docs.forEach((docSnap) => {
    matchedDocs.set(docSnap.id, docSnap.ref);
  });

  const idSnapshot = await getDocs(
    query(responsesRef, where("id", "==", cleanResponseId)),
  );

  idSnapshot.docs.forEach((docSnap) => {
    matchedDocs.set(docSnap.id, docSnap.ref);
  });

  if (!matchedDocs.size) {
    throw new Error(
      `Could not find the generated response to approve. Checked response ID "${cleanResponseId}".`,
    );
  }

  await Promise.all(
    Array.from(matchedDocs.values()).map((docRef) =>
      updateDoc(docRef, {
        status: "Approved",
        approvedAt: serverTimestamp(),
        approvedByEmail,
        approvedSubmissionId,
        updatedAt: serverTimestamp(),
      }),
    ),
  );
};
